<template>
    <RouterView />
</template>

<script type="text/babel">
import { COMPONENT_NAMES } from '../constants';

export default {
    name: COMPONENT_NAMES.WANDER_MANAGEMENT,
};
</script>

<style scoped></style>
